import { provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ValidationRulesFacade } from './facade/validation-rules.facade';
import { ValidationRulesService } from './service/validation-rules.service';
import { validationRulesStateKey } from './state';
import { ValidationRulesEffects } from './state/effects/validation-rules.effects';
import { ValidationRulesReducer } from './state/reducers/validation-rules.reducer';
import { ValidationRulesRoutes } from './validation-rules.routing';

/**
 * Feature config aggregating the NgRx slice, effects, router routes, and
 * DI registrations for the Validation Rules admin feature. Spread into
 * `app.config.ts` next to the other feature configs.
 *
 * No localStorage meta-reducer is registered: validation rules are admin
 * state that should always be fetched fresh from the server (a stale cache
 * could let an admin think they edited a rule they didn't).
 */
export const validationRulesConfig = [
  provideState(validationRulesStateKey, ValidationRulesReducer),
  provideEffects([ValidationRulesEffects]),
  provideRouter(ValidationRulesRoutes),
  ValidationRulesFacade,
  ValidationRulesService,
];
